/*
 *
 * PayBalance reducer
 *
 */

import { fromJS } from 'immutable';
import {
  PAY_BALANCE_CONSTANT,
  DEFAULT_ACTION,
  FETCH_PAY_BALANCE_SUCCESS,
  ADD_CARD_SUCCESS,
  OTP_SUBMIT,
} from './constants';
import { YBL_KYC_STATIC_DATA } from '../YblMinKyc/constants';
import { PAY_BALANCE_CONSTANTS } from '../YblMinKycExistingUsers/constants';

const initialState = fromJS({
  total_balance: 0,
  yscs: [],
  zscs: [],
  zaggle_cash: 0,
  add_card_obj: {},
  otp_response: {},
  isLoading: false,
  walletBalance: { status: false },
  nsdlWalletBalance: { status: false },
  xml_m2p_kyc: {},
  has_indusind_card: false,
  min_kyc_required: false,
  generate_Otp_Ysc: {},
  ybl_otp_success: {},
  ybl_otp_verified: {},
  yblMinKyc: {},
  kycStaticData: {},
  yblMinKycExistingUsers: {},
});

function payBalanceReducer(state = initialState, action) {
  const { payload } = action;
  switch (action.type) {
    case DEFAULT_ACTION:
      return state.set('isLoading', payload);
    case FETCH_PAY_BALANCE_SUCCESS: {
      const { total_balance, yscs, zscs, zaggle_cash, has_indusind_card, min_kyc_required } = payload;
      return state
        .set('total_balance', fromJS(total_balance))
        .set('zaggle_cash', fromJS(zaggle_cash))
        .set('yscs', fromJS(yscs))
        .set('zscs', fromJS(zscs))
        .set('has_indusind_card', fromJS(has_indusind_card))
        .set('min_kyc_required', fromJS(min_kyc_required))
        .set('isLoading', false);
    }
    case ADD_CARD_SUCCESS:
      return state
        .set('add_card_obj', fromJS(action.payload))
        .set('isLoading', false);
    case OTP_SUBMIT:
      return state
        .set('otp_response', fromJS(payload))
        .set('isLoading', false);
    case PAY_BALANCE_CONSTANT.SET_WALLET_BALLANCE:
      return state
        .set('walletBalance', fromJS(action.payload))
        .set('isLoading', false);
    case PAY_BALANCE_CONSTANT.SET_NSDL_WALLET_BALLANCE:
      return state
        .set('nsdlWalletBalance', fromJS(action.payload))
        .set('isLoading', false);
    case PAY_BALANCE_CONSTANT.XML_M2P_KYC_SUCCESS: {
      return state
        .set('xml_m2p_kyc', fromJS(action.payload))
        .set('isLoading', false);
    }
    case PAY_BALANCE_CONSTANT.SET_GENERATE_OTP_YSC: {
      return state
        .set('generate_Otp_Ysc', fromJS(action.payload))
        .set('isLoading', false);
    }
    case PAY_BALANCE_CONSTANT.SET_YBL_OTP_SUCCESS: {
      return state
        .set('ybl_otp_success', fromJS(action.payload))
        .set('isLoading', false);
    }
    case PAY_BALANCE_CONSTANT.SET_YBL_OTP_VERIFIED: {
      return state
        .set('ybl_otp_verified', fromJS(action.payload))
        .set('isLoading', false);
    }
    case PAY_BALANCE_CONSTANT.FETCH_YBL_MIN_KYC: {
      return state
        .set('yblMinKyc', fromJS(action.payload))
        .set('isLoading', false);
    }
    case YBL_KYC_STATIC_DATA: {
      return state
        .set('kycStaticData', fromJS(action.payload))
        .set('isLoading', false);
    }
    case PAY_BALANCE_CONSTANTS.FETCH_YBL_MIN_KYC_EXISTING_USERS: {
      return state
        .set('yblMinKycExistingUsers', fromJS(action.payload))
        .set('isLoading', false);
    }

    default:
      return state;
  }
}

export default payBalanceReducer;



// WEBPACK FOOTER //
// client/containers/PayBalance/reducer.js